import { _ } from "../helpers/dom-selectors.js";
const CONFIG = Object.freeze({
    IS_TOUCH_DEVICE: 'ontouchstart' in document.documentElement,
    USER_EMAIL: _('settingsView')?.getAttribute('data-email')
});
export default CONFIG;
